import { Link } from "react-router-dom";
import ShweebumCat from "./ShweebumCat";

const SiteFooter = () => {
  return (
    <footer className="bg-slate-800 text-slate-300 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <ShweebumCat size="sm" />
              <span className="font-literary text-xl text-white">Shweebum</span>
            </div>
            <p className="text-sm">
              AI-powered book writing made simple. Created with love by a family who believes in the power of stories.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/reviews" className="hover:text-white">Reviews</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
              <li><a href="mailto:shweebum@outlook.com" className="hover:text-white">shweebum@outlook.com</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">About</h4>
            <p className="text-sm">
              <strong>You Inspire Designs LLC</strong><br />
              Southeast USA<br />
              Family-owned since 2024
            </p>
          </div>
        </div>
        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} You Inspire Designs LLC. All rights reserved.</p>
          <p className="mt-2 text-muted-foreground">Proudly Pro-America | Pro-Christian | Family Values</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
